import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { TextareaLabel, TextareaInput, TextareaWrapperContainer, TextareaErrorMessage } from "./styled";
import { Flex, FlexSpan } from "../Grid";
export const Textarea = ({ value, defaultValue, placeholder, disabled, height, width, maxLength, label, labelExtra, labelPosition = "top", autofocus, error, errorMessage, onChange, onKeyDown, onFocus, onBlur, }) => {
    const inputRef = useRef(null);
    const [ownValue, setOwnValue] = useState(value || defaultValue || "");
    const [focused, setFocused] = useState(false);
    useEffect(() => {
        if (inputRef.current && autofocus) {
            inputRef.current.focus();
        }
    }, [inputRef, autofocus]);
    return (_jsxs(TextareaWrapperContainer, { children: [_jsxs(Flex, { alignItems: labelPosition !== "top" ? "center" : undefined, flexDirection: labelPosition === "top"
                    ? "column"
                    : labelPosition === "right"
                        ? "row-reverse"
                        : "row", children: [label && (_jsx(FlexSpan, { onClick: e => e.stopPropagation(), mr: labelPosition === "left" ? "1rem" : undefined, ml: labelPosition === "right" ? "1rem" : undefined, textAlign: labelPosition === "left" ? "right" : undefined, children: _jsxs(TextareaLabel, { children: [_jsx(FlexSpan, { children: label }), labelExtra && (_jsx(FlexSpan, { display: "flex", ml: "0.5rem", children: labelExtra }))] }) })), _jsx(FlexSpan, { children: _jsx(TextareaInput, { ref: inputRef, isFocused: focused, maxLength: maxLength, value: value || ownValue, placeholder: placeholder, error: error, onFocus: () => {
                                setFocused(true);
                                onFocus?.();
                            }, onBlur: () => {
                                setFocused(false);
                                onBlur?.();
                            }, onChange: (e) => {
                                const currentValue = e.target.value;
                                onChange?.(currentValue);
                                setOwnValue(currentValue);
                            }, onKeyDown: onKeyDown, disabled: disabled, height: height, width: width }) })] }), errorMessage && _jsx(TextareaErrorMessage, { onClick: e => e.stopPropagation(), children: errorMessage })] }));
};
